(function () {
  var API_BASE = window.BRACLO_CHAT_API_BASE || '';
  var STORAGE_TOKEN = 'bracloChatToken';
  var STORAGE_ORDER_NAME = 'bracloChatOrderName';

  var bubble = document.getElementById('bracloChatBubble');
  var windowEl = document.getElementById('bracloChatWindow');
  var closeBtn = document.getElementById('bracloChatClose');
  var body = document.getElementById('bracloChatBody');
  var input = document.getElementById('bracloChatInput');
  var sendBtn = document.getElementById('bracloChatSend');
  if (!bubble || !windowEl || !body) return;

  var state = {
    open: false,
    token: sessionStorage.getItem(STORAGE_TOKEN) || null,
    orderName: sessionStorage.getItem(STORAGE_ORDER_NAME) || null,
    order: null,
    booted: false,
    chatHistory: []
  };

  function toggle(open) {
    state.open = typeof open === 'boolean' ? open : !state.open;
    windowEl.hidden = !state.open;
    bubble.setAttribute('aria-expanded', String(state.open));
    if (state.open && !state.booted) {
      state.booted = true;
      try {
        showWelcome();
      } catch (err) {
        body.textContent = 'Widget error: ' + (err && err.message ? err.message : err);
      }
    }
  }

  bubble.addEventListener('click', function () { toggle(); });
  if (closeBtn) closeBtn.addEventListener('click', function () { toggle(false); });

  function el(tag, className, html) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }

  function scrollToBottom() {
    body.scrollTop = body.scrollHeight;
  }

  function addBot(html) {
    var msg = el('div', 'braclo-msg braclo-msg-bot', html);
    body.appendChild(msg);
    scrollToBottom();
    return msg;
  }

  function addUser(text) {
    var msg = el('div', 'braclo-msg braclo-msg-user');
    msg.textContent = text;
    body.appendChild(msg);
    scrollToBottom();
    return msg;
  }

  function addCard(contentEl) {
    var wrap = el('div', 'braclo-msg braclo-msg-card');
    wrap.appendChild(contentEl);
    body.appendChild(wrap);
    scrollToBottom();
    return wrap;
  }

  function clearAndShow(builderFn) {
    body.innerHTML = '';
    builderFn();
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function api(path, options) {
    options = options || {};
    var headers = Object.assign({ 'Content-Type': 'application/json' }, options.headers || {});
    return fetch(API_BASE + path, {
      method: options.method || 'GET',
      headers: headers,
      body: options.body ? JSON.stringify(options.body) : undefined
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data && data.error ? data.error : 'Something went wrong.');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  // ---------- Free-text AI chat ----------
  // Sits alongside the button-driven flows below (untouched) rather than
  // replacing them - order-specific actions still only happen through the
  // verified menu flows. This is for general questions typed in plain
  // language (policy, sizing, product info) that the menu doesn't cover.

  function showTypingIndicator() {
    var wrap = el('div', 'braclo-msg-typing');
    wrap.id = 'bracloTypingIndicator';
    wrap.innerHTML = '<span></span><span></span><span></span>';
    body.appendChild(wrap);
    scrollToBottom();
  }

  function removeTypingIndicator() {
    var existing = document.getElementById('bracloTypingIndicator');
    if (existing) existing.remove();
  }

  function sendFreeTextMessage() {
    if (!input) return;
    var text = input.value.trim();
    if (!text) return;
    addUser(text);
    input.value = '';
    input.disabled = true;
    if (sendBtn) sendBtn.disabled = true;
    showTypingIndicator();
    api('/api/chat/ask', { method: 'POST', body: { message: text, history: state.chatHistory } })
      .then(function (data) {
        removeTypingIndicator();
        addBot(escapeHtml(data.reply));
        state.chatHistory.push({ role: 'user', text: text });
        state.chatHistory.push({ role: 'bot', text: data.reply });
        if (state.chatHistory.length > 12) {
          state.chatHistory = state.chatHistory.slice(-12);
        }
      })
      .catch(function (err) {
        removeTypingIndicator();
        addBot(escapeHtml(err.message || 'Something went wrong. Please try again.'));
      })
      .finally(function () {
        input.disabled = false;
        if (sendBtn) sendBtn.disabled = false;
        input.focus();
      });
  }

  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        sendFreeTextMessage();
      }
    });
  }
  if (sendBtn) {
    sendBtn.addEventListener('click', sendFreeTextMessage);
  }

  // ---------- Welcome / menu ----------

  function showWelcome() {
    addBot('Hi, I’m <strong>Braclo AI</strong>. Ask me anything, or pick an option below to manage an order:');
    showMenu();
  }

  var ACTIONS = [
    { key: 'track', label: 'Track My Order', icon: '📦' },
    { key: 'address', label: 'Change Address', icon: '📍' },
    { key: 'cancel', label: 'Cancel My Order', icon: '✕' },
    { key: 'return', label: 'Request a Return', icon: '↺' },
    { key: 'ticket', label: 'Raise a Ticket', icon: '🎫' }
  ];

  function showMenu() {
    var wrap = el('div', 'braclo-menu');
    ACTIONS.forEach(function (a) {
      var btn = el('button', 'braclo-menu-btn');
      btn.type = 'button';
      btn.innerHTML = '<span class="braclo-menu-icon">' + a.icon + '</span><span>' + a.label + '</span>';
      btn.addEventListener('click', function () { startFlow(a.key); });
      wrap.appendChild(btn);
    });
    addCard(wrap);
  }

  // ---------- Verify gate ----------

  function startFlow(flow) {
    addUser(ACTIONS.filter(function (a) { return a.key === flow; })[0].label);
    if (flow === 'ticket') {
      renderTicketForm();
      return;
    }
    if (flow === 'track') {
      if (state.token && state.order) {
        routeFlow(flow);
        return;
      }
      if (state.token) {
        api('/api/chat/order/' + encodeURIComponent(state.token))
          .then(function (data) {
            state.order = data.order;
            routeFlow(flow);
          })
          .catch(function () {
            clearSession();
            renderQuickTrackForm();
          });
        return;
      }
      renderQuickTrackForm();
      return;
    }
    if (state.token && state.order) {
      routeFlow(flow);
      return;
    }
    if (state.token) {
      // token cached but we haven't re-fetched the order this page load yet
      api('/api/chat/order/' + encodeURIComponent(state.token))
        .then(function (data) {
          state.order = data.order;
          routeFlow(flow);
        })
        .catch(function () {
          clearSession();
          renderVerifyForm(flow);
        });
      return;
    }
    renderVerifyForm(flow);
  }

  function clearSession() {
    state.token = null;
    state.order = null;
    sessionStorage.removeItem(STORAGE_TOKEN);
    sessionStorage.removeItem(STORAGE_ORDER_NAME);
  }

  // Default verification path: mobile number, then a one-time code emailed
  // to the order's registered email. Stronger than order-number + email
  // (proves the customer can actually read that inbox right now, not just
  // that they know two static facts) - see routes/chat.js's order-otp
  // endpoints. The old order-number + email form is still reachable via a
  // fallback link, for orders placed without a phone number on file.
  function renderVerifyForm(pendingFlow) {
    addBot('First, let’s verify it’s you. Enter the mobile number used on your order — we’ll email a code to your registered email.');
    var form = el('form', 'braclo-form');
    form.innerHTML =
      '<label>Mobile number<input type="tel" name="phone" placeholder="e.g. 9876543210" required></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Send verification code</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var phone = form.phone.value.trim();
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Looking...';
      api('/api/chat/phone-lookup', { method: 'POST', body: { phone: phone } })
        .then(function (data) {
          addUser(phone);
          if (data.orders.length === 1) {
            requestOrderOtp(data.orders[0], pendingFlow);
          } else {
            renderOrderPickerForOtp(data.orders, pendingFlow);
          }
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send verification code';
        });
    });
    addCard(form);

    var fallback = el('p', null, '<a href="#" id="verifyFallbackLink" style="font-size:.78rem;color:var(--muted,#888);text-decoration:underline;cursor:pointer;">Verify with order number instead</a>');
    addCard(fallback);
    fallback.querySelector('#verifyFallbackLink').addEventListener('click', function (e) {
      e.preventDefault();
      renderOrderNumberVerifyForm(pendingFlow);
    });
  }

  function renderOrderPickerForOtp(orders, pendingFlow) {
    addBot('Found ' + orders.length + ' orders with that number — which one?');
    var wrap = el('div', 'braclo-menu');
    orders.forEach(function (o) {
      var btn = el('button', 'braclo-menu-btn');
      btn.type = 'button';
      btn.innerHTML = '<span class="braclo-menu-icon">📦</span><span>' + escapeHtml(o.name) + ' — ' + new Date(o.createdAt).toLocaleDateString() + '</span>';
      btn.addEventListener('click', function () { requestOrderOtp(o, pendingFlow); });
      wrap.appendChild(btn);
    });
    addCard(wrap);
  }

  function requestOrderOtp(order, pendingFlow) {
    api('/api/chat/order-otp/request', { method: 'POST', body: { orderId: order.id } })
      .then(function (data) {
        renderOtpForm(order, data.emailMasked, pendingFlow);
      })
      .catch(function (err) {
        addBot(err.message || 'Something went wrong. Please try again.');
        addBackToMenu();
      });
  }

  function renderOtpForm(order, emailMasked, pendingFlow) {
    addBot('We’ve sent a 6-digit code to <strong>' + escapeHtml(emailMasked) + '</strong>.');
    var form = el('form', 'braclo-form');
    form.innerHTML =
      '<label>Verification code<input type="text" name="otp" inputmode="numeric" maxlength="6" placeholder="123456" required></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Verify</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var otp = form.otp.value.trim();
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Verifying...';
      api('/api/chat/order-otp/verify', { method: 'POST', body: { orderId: order.id, otp: otp } })
        .then(function (data) {
          state.token = data.token;
          state.order = data.order;
          sessionStorage.setItem(STORAGE_TOKEN, data.token);
          sessionStorage.setItem(STORAGE_ORDER_NAME, data.order.name);
          addBot('Verified — found order <strong>' + escapeHtml(data.order.name) + '</strong>.');
          routeFlow(pendingFlow);
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Verify';
        });
    });
    addCard(form);
  }

  // Fallback for orders placed without a phone number on file.
  function renderOrderNumberVerifyForm(pendingFlow) {
    addBot('Please share your order number and the email used at checkout.');
    var form = el('form', 'braclo-form');
    form.innerHTML =
      '<label>Order number<input type="text" name="orderNumber" placeholder="e.g. 1024" required></label>' +
      '<label>Email<input type="email" name="email" placeholder="you@example.com" required></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Find my order</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var orderNumber = form.orderNumber.value.trim();
      var email = form.email.value.trim();
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Looking...';
      api('/api/chat/verify', { method: 'POST', body: { orderNumber: orderNumber, email: email } })
        .then(function (data) {
          state.token = data.token;
          state.order = data.order;
          sessionStorage.setItem(STORAGE_TOKEN, data.token);
          sessionStorage.setItem(STORAGE_ORDER_NAME, data.order.name);
          addUser(orderNumber + ' / ' + email);
          addBot('Got it — found order <strong>' + escapeHtml(data.order.name) + '</strong>.');
          routeFlow(pendingFlow);
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Find my order';
        });
    });
    addCard(form);
  }

  // ---------- Quick track (single identifier) ----------
  // Deliberately read-only: quick-track never stores state.token, so if the
  // customer picks any other action from the "Anything else?" menu after
  // tracking, startFlow() falls through to the full order-number + email
  // verify gate above - same enforcement mirrored server-side via the
  // 'track' vs 'full' token scope, since a phone/email/order number alone
  // is too easy to guess to unlock address changes, cancellation, or returns.

  function renderQuickTrackForm() {
    addBot('Enter your mobile number, email, or order ID to track your order.');
    var form = el('form', 'braclo-form');
    form.innerHTML =
      '<label>Mobile number, email, or order ID<input type="text" name="identifier" placeholder="e.g. 9876543210, you@example.com, or 1024" required></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Track my order</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var identifier = form.identifier.value.trim();
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Looking...';
      api('/api/chat/quick-track', { method: 'POST', body: { identifier: identifier } })
        .then(function (data) {
          addUser(identifier);
          if (data.orders.length === 1) {
            renderTrack(data.orders[0]);
          } else {
            renderOrderPicker(data.orders);
          }
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Track my order';
        });
    });
    addCard(form);
  }

  function renderOrderPicker(orders) {
    addBot('Found ' + orders.length + ' orders — which one would you like to track?');
    var wrap = el('div', 'braclo-menu');
    orders.forEach(function (o) {
      var btn = el('button', 'braclo-menu-btn');
      btn.type = 'button';
      btn.innerHTML = '<span class="braclo-menu-icon">📦</span><span>' + escapeHtml(o.name) + ' — ' + new Date(o.createdAt).toLocaleDateString() + '</span>';
      btn.addEventListener('click', function () { renderTrack(o); });
      wrap.appendChild(btn);
    });
    addCard(wrap);
  }

  function routeFlow(flow) {
    if (flow === 'track') return renderTrack();
    if (flow === 'address') return renderAddressForm();
    if (flow === 'cancel') return renderCancelConfirm();
    if (flow === 'return') return renderReturnForm();
  }

  // ---------- Support ticket ----------
  // No order verification needed - a customer may be asking a general
  // question, or one about an order they can't currently verify. Order
  // number is just a free-text field they can optionally fill in themselves.

  var TICKET_CATEGORIES = ['Order Issue', 'Payment / Refund', 'Product Question', 'Website / Technical', 'Other'];

  function renderTicketForm() {
    addBot('Tell us what’s going on and we’ll get back to you by email.');
    var form = el('form', 'braclo-form');
    var prefillOrder = state.order ? state.order.name : '';
    form.innerHTML =
      '<label>Your name<input type="text" name="name" placeholder="Full name"></label>' +
      '<label>Email<input type="email" name="email" placeholder="you@example.com" required></label>' +
      '<label>Order number (optional)<input type="text" name="orderNumber" placeholder="e.g. 1024" value="' + escapeHtml(prefillOrder) + '"></label>' +
      '<label>Category<select name="category">' +
      TICKET_CATEGORIES.map(function (c) { return '<option value="' + escapeHtml(c) + '">' + escapeHtml(c) + '</option>'; }).join('') +
      '</select></label>' +
      '<label>What’s going on?<textarea name="message" rows="3" required></textarea></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Submit ticket</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      api('/api/chat/ticket', {
        method: 'POST',
        body: {
          name: form.name.value.trim(),
          email: form.email.value.trim(),
          orderNumber: form.orderNumber.value.trim(),
          category: form.category.value,
          message: form.message.value.trim()
        }
      })
        .then(function (data) {
          addBot('Ticket <strong>' + escapeHtml(data.ticketId) + '</strong> has been raised — we’ll email you at <strong>' + escapeHtml(form.email.value.trim()) + '</strong> shortly. ✅');
          addBackToMenu();
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit ticket';
        });
    });
    addCard(form);
  }

  // ---------- Track ----------

  function money(m) {
    if (!m) return '';
    return m.amount + ' ' + m.currencyCode;
  }

  function renderTrack(order) {
    var o = order || state.order;
    var lines = o.lineItems.map(function (li) {
      return '<li>' + li.quantity + '× ' + escapeHtml(li.title) + '</li>';
    }).join('');
    var tracking = '';
    o.fulfillments.forEach(function (f) {
      (f.trackingInfo || []).forEach(function (t) {
        if (t.url) {
          tracking += '<div class="braclo-tracking"><a href="' + t.url + '" target="_blank" rel="noopener">Track with ' + escapeHtml(t.company || 'carrier') + ' →</a></div>';
        }
      });
    });
    addBot(
      '<div class="braclo-order-summary">' +
      '<div class="braclo-order-title">' + escapeHtml(o.name) + '</div>' +
      '<div class="braclo-order-status">' + escapeHtml(o.fulfillmentStatus) + ' · ' + escapeHtml(o.financialStatus) + '</div>' +
      '<ul class="braclo-order-items">' + lines + '</ul>' +
      '<div class="braclo-order-total">Total: ' + money(o.total) + '</div>' +
      tracking +
      '</div>'
    );
    if (o.cancelledAt) {
      addBot('This order was cancelled on ' + new Date(o.cancelledAt).toLocaleDateString() + '.');
    }
    addBackToMenu();
  }

  // ---------- Address ----------

  function renderAddressForm() {
    var o = state.order;
    if (o.cancelledAt) {
      addBot('This order is cancelled, so its address can’t be changed.');
      return addBackToMenu();
    }
    if (o.fulfillmentStatus !== 'UNFULFILLED') {
      addBot('This order has already started shipping, so I can’t change the address here. Please <a href="/pages/contact">contact us</a> and we’ll help.');
      return addBackToMenu();
    }
    var a = o.shippingAddress || {};
    var form = el('form', 'braclo-form');
    form.innerHTML =
      '<label>Address line 1<input type="text" name="address1" value="' + escapeHtml(a.address1) + '" required></label>' +
      '<label>Address line 2<input type="text" name="address2" value="' + escapeHtml(a.address2) + '"></label>' +
      '<label>City<input type="text" name="city" value="' + escapeHtml(a.city) + '" required></label>' +
      '<label>State / Province code<input type="text" name="provinceCode" placeholder="e.g. MH" ></label>' +
      '<label>PIN / ZIP<input type="text" name="zip" value="' + escapeHtml(a.zip) + '" required></label>' +
      '<label>Phone<input type="text" name="phone" value="' + escapeHtml(a.phone) + '"></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Update address</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Updating...';
      var address = {
        address1: form.address1.value.trim(),
        address2: form.address2.value.trim(),
        city: form.city.value.trim(),
        provinceCode: form.provinceCode.value.trim(),
        zip: form.zip.value.trim(),
        phone: form.phone.value.trim(),
        countryCode: 'IN'
      };
      api('/api/chat/update-address', { method: 'POST', body: { token: state.token, address: address } })
        .then(function () {
          addBot('Your shipping address has been updated. ✅');
          addBackToMenu();
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Update address';
        });
    });
    addCard(form);
  }

  // ---------- Cancel ----------

  function renderCancelConfirm() {
    var o = state.order;
    if (o.cancelledAt) {
      addBot('This order is already cancelled.');
      return addBackToMenu();
    }
    if (o.fulfillmentStatus !== 'UNFULFILLED') {
      addBot('This order can’t be cancelled as it’s already in transit. You can simply reject the order when it arrives at your doorstep.');
      return addBackToMenu();
    }
    var refundClause = o.isCod
      ? 'This is a Cash on Delivery order, so no refund is applicable'
      : 'and refund <strong>' + money(o.total) + '</strong> to your original payment method';
    var wrap = el('div', 'braclo-confirm');
    wrap.innerHTML =
      '<p>Cancel order <strong>' + escapeHtml(o.name) + '</strong> ' + refundClause + '? This can’t be undone.</p>' +
      '<div class="braclo-confirm-actions">' +
      '<button type="button" class="braclo-btn braclo-btn-danger" data-action="confirm">Yes, cancel my order</button>' +
      '<button type="button" class="braclo-btn braclo-btn-ghost" data-action="back">Never mind</button>' +
      '</div><div class="braclo-form-error" hidden></div>';
    wrap.querySelector('[data-action="back"]').addEventListener('click', function () {
      addBot('No problem — your order is untouched.');
      addBackToMenu();
    });
    wrap.querySelector('[data-action="confirm"]').addEventListener('click', function () {
      var errorEl = wrap.querySelector('.braclo-form-error');
      var confirmBtn = wrap.querySelector('[data-action="confirm"]');
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Cancelling...';
      api('/api/chat/cancel', { method: 'POST', body: { token: state.token } })
        .then(function () {
          var resultMsg = o.isCod
            ? 'Your order has been cancelled. ✅ As this was a Cash on Delivery order, no payment was collected, so there’s no refund to process.'
            : 'Your order has been cancelled. ✅ Your refund will be initiated shortly to your original payment method.';
          addBot(resultMsg);
          addBackToMenu();
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          confirmBtn.disabled = false;
          confirmBtn.textContent = 'Yes, cancel my order';
        });
    });
    addCard(wrap);
  }

  // ---------- Return ----------

  function renderReturnForm() {
    var o = state.order;
    var allLineItems = [];
    var hasPendingReturn = false;
    o.fulfillments.forEach(function (f) {
      if (f.status === 'CANCELED') return;
      (f.lineItems || []).forEach(function (li) {
        if (li.returnRequested) { hasPendingReturn = true; return; }
        allLineItems.push(li);
      });
    });
    if (!allLineItems.length && hasPendingReturn) {
      addBot('You already have a return request in progress for the item(s) on this order. Please check your email or contact us for an update.');
      return addBackToMenu();
    }
    if (!allLineItems.length) {
      addBot('This order hasn’t shipped yet, so there’s nothing to return yet. If you’d like to cancel it instead, choose “Cancel My Order.”');
      return addBackToMenu();
    }
    var form = el('form', 'braclo-form');
    var itemsHtml = allLineItems.map(function (li, i) {
      return '<label class="braclo-checkbox"><input type="checkbox" name="item" value="' + i + '"> ' + li.quantity + '× ' + escapeHtml(li.title) + '</label>';
    }).join('');
    form.innerHTML =
      '<div class="braclo-form-label">Which item(s) would you like to return?</div>' +
      itemsHtml +
      '<label>Reason<select name="reason">' +
      '<option value="WRONG_ITEM">Wrong item</option>' +
      '<option value="SIZE_TOO_SMALL">Too small</option>' +
      '<option value="SIZE_TOO_LARGE">Too large</option>' +
      '<option value="DEFECTIVE">Damaged / defective</option>' +
      '<option value="UNWANTED">Changed my mind</option>' +
      '<option value="OTHER">Other</option>' +
      '</select></label>' +
      '<label>Anything else? (optional)<textarea name="note" rows="2"></textarea></label>' +
      '<button type="submit" class="braclo-btn braclo-btn-primary">Request return</button>' +
      '<div class="braclo-form-error" hidden></div>';
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var checked = Array.prototype.slice.call(form.querySelectorAll('input[name="item"]:checked'));
      var errorEl = form.querySelector('.braclo-form-error');
      errorEl.hidden = true;
      if (!checked.length) {
        errorEl.textContent = 'Please select at least one item.';
        errorEl.hidden = false;
        return;
      }
      var lineItems = checked.map(function (cb) {
        var li = allLineItems[Number(cb.value)];
        return { fulfillmentLineItemId: li.fulfillmentLineItemId, quantity: li.quantity };
      });
      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      api('/api/chat/return', {
        method: 'POST',
        body: { token: state.token, lineItems: lineItems, reason: form.reason.value, note: form.note.value }
      })
        .then(function () {
          addBot('Your return request has been submitted — our team will review and confirm shortly. ✅');
          addBackToMenu();
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Request return';
        });
    });
    addCard(form);
  }

  // ---------- Shared ----------

  function addBackToMenu() {
    var btn = el('button', 'braclo-btn braclo-btn-ghost', 'Anything else?');
    btn.type = 'button';
    btn.addEventListener('click', function () { showMenu(); });
    addCard(btn);
  }
})();
